import styled, { css } from 'styled-components';
import { colorCSS } from '../../styles';
export const BxpLink = styled.div `
  display: ${({ bxpIsBlock }) => (bxpIsBlock ? 'block' : 'inline-block')};
  a, > span {
    ${({ bxpAppearance }) => bxpAppearance}
    ${({ bxpSpacing }) => bxpSpacing}
    ${({ bxpProminence }) => bxpProminence}
  }
`;
export const BxpButton = styled.div `
  display: ${({ bxpIsBlock }) => (bxpIsBlock ? 'block' : 'inline-block')};
  button {
    appearance: none;
    ${({ bxpAppearance }) => bxpAppearance}
    ${({ bxpSpacing }) => bxpSpacing}
    ${({ bxpProminence }) => bxpProminence}
    &:focus {
      outline: none;
    }
  }
`;
export function getAppearance(appearance, style) {
    switch (appearance) {
        case 'Creative':
            return style == 'Outline' ? creativeOutlineButton : creativeButton;
        case 'Light':
            return style == 'Outline' ? lightOutlineButton : lightButton;
        case 'Muted':
            return style == 'Outline' ? mutedOutlineButton : mutedButton;
        case 'Neutral':
            return style == 'Outline' ? neutralOutlineButton : neutralButton;
        default:
            return defaultButton;
    }
}
export function getProminence(prominence) {
    switch (prominence) {
        case 'Elevated':
            return css `
        font-size: 1.5rem;
        padding: 0.7rem 1.5rem 0.8rem;
      `;
        case 'Reduced':
            return css `
        font-size: 1rem;
        padding: 0.3rem 0.6rem 0.4rem;
      `;
        default:
            return css `
        font-size: 1.25rem;
        padding: 0.4rem 1.5rem 0.5rem;
      `;
    }
}
export function getSpacing(spacing) {
    switch (spacing) {
        case 'Left':
            return css `
        margin-left: 0.75rem;
      `;
        case 'Right':
            return css `
        margin-right: 0.75rem;
      `;
        case 'LeftRight':
            return css `
        margin-left: 0.75rem;
        margin-right: 0.75rem;
      `;
        case 'LeftBottom':
            return css `
        margin-bottom: 0.75rem;
        margin-left: 0.75rem;
      `;
        case 'RightBottom':
            return css `
        margin-bottom: 0.75rem;
        margin-right: 0.75rem;
      `;
        case 'LeftRightBottom':
            return css `
        margin-bottom: 0.75rem;
        margin-left: 0.75rem;
        margin-right: 0.75rem;
      `;
        default:
            return css ``;
    }
}
const defaultButton = css `
  border-radius: 0.3rem;
  display: inline-flex;
  align-items: center;
  transition: all 250ms ease-out;
  span {
    display: inline-block;
  }
  svg {
    display: inline-block;
    margin-left: 0.5rem;
    margin-top: 2px;
    transform: translate3d(0px, 0, 0);
    transition: transform 250ms ease-out;
  }
  &:hover svg {
    transform: translate3d(3px, 0, 0);
  }
`;
const creativeButton = css `
  ${defaultButton}
  background-color: ${colorCSS('G300')};
  border: 1px solid ${colorCSS('G300')};
  color: ${colorCSS('N0')} !important;
  text-decoration: none;
  &:hover {
    background-color: ${colorCSS('G400')};
    border-color: ${colorCSS('G400')};
    text-decoration: none;
  }
  &:active {
    background-color: ${colorCSS('G500')};
    border-color: ${colorCSS('G500')};
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem ${colorCSS('G400', 0.5)};
  }
`;
const creativeOutlineButton = css `
  ${defaultButton}
  border: 1px solid ${colorCSS('G300')};
  color: ${colorCSS('G300')} !important;
  text-decoration: none;
  &:hover {
    background-color: ${colorCSS('G400', 0.1)};
    border-color: ${colorCSS('G400')};
    color: ${colorCSS('G400')} !important;
    text-decoration: none;
  }
  &:active {
    background-color: ${colorCSS('G500', 0.1)};
    border-color: ${colorCSS('G500')};
    color: ${colorCSS('G500')} !important;
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem ${colorCSS('G400', 0.5)};
  }
`;
const lightButton = css `
  ${defaultButton}
  background-color: ${colorCSS('N0')};
  border: 1px solid ${colorCSS('N0')};
  color: ${colorCSS('N900')} !important;
  text-decoration: none;
  &:hover {
    background-color: ${colorCSS('N20')};
    border-color: ${colorCSS('N20')};
    text-decoration: none;
  }
  &:active {
    background-color: ${colorCSS('N40')};
    border-color: ${colorCSS('N40')};
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem ${colorCSS('N20', 0.5)};
  }
`;
const lightOutlineButton = css `
  ${defaultButton}
  border: 1px solid ${colorCSS('N0')};
  color: ${colorCSS('N0')} !important;
  text-decoration: none;
  &:hover {
    background-color: ${colorCSS('N0', 0.1)};
    border-color: ${colorCSS('N0', 0.9)};
    color: ${colorCSS('N0')} !important;
    text-decoration: none;
  }
  &:active {
    background-color: ${colorCSS('N0', 0.2)};
    border-color: ${colorCSS('N0', 0.2)};
    color: ${colorCSS('N0')} !important;
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem ${colorCSS('N0', 0.5)};
  }
`;
const mutedButton = css `
  ${defaultButton}
  background-color: ${colorCSS('N40')};
  border: 1px solid ${colorCSS('N40')};
  color: ${colorCSS('N900')} !important;
  text-decoration: none;
  &:hover {
    background-color: ${colorCSS('N50')};
    border-color: ${colorCSS('N50')};
    text-decoration: none;
  }
  &:active {
    background-color: ${colorCSS('N60')};
    border-color: ${colorCSS('N60')};
    color: ${colorCSS('N900', 0.9)} !important;
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem ${colorCSS('N50', 0.4)};
  }
`;
const mutedOutlineButton = css `
  ${defaultButton}
  border: 1px solid ${colorCSS('N80')};
  color: ${colorCSS('N200')} !important;
  text-decoration: none;
  &:hover {
    background-color: ${colorCSS('N90', 0.1)};
    border-color: ${colorCSS('N90')};
    text-decoration: none;
  }
  &:active {
    background-color: ${colorCSS('N100', 0.1)};
    border-color: ${colorCSS('N100')};
    color: ${colorCSS('N300')} !important;
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem ${colorCSS('N90', 0.4)};
  }
`;
const neutralButton = css `
  ${defaultButton}
  background-color: ${colorCSS('N90')};
  border: 1px solid ${colorCSS('N90')};
  color: ${colorCSS('N0')} !important;
  text-decoration: none;
  &:hover {
    background-color: ${colorCSS('N100')};
    border-color: ${colorCSS('N100')};
    text-decoration: none;
  }
  &:active {
    background-color: ${colorCSS('N200')};
    border-color: ${colorCSS('N200')};
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem ${colorCSS('N100', 0.5)};
  }
`;
const neutralOutlineButton = css `
  ${defaultButton}
  border: 1px solid ${colorCSS('N90')};
  color: ${colorCSS('N90')};
  text-decoration: none;
  &:hover {
    background-color: ${colorCSS('N100', 0.1)};
    border-color: ${colorCSS('N100')};
    color: ${colorCSS('N100')} !important;
    text-decoration: none;
  }
  &:active {
    background-color: ${colorCSS('N200', 0.1)};
    border-color: ${colorCSS('N200')};
    color: ${colorCSS('N200')} !important;
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem ${colorCSS('N100', 0.5)};
  }
`;
//# sourceMappingURL=link-button.styles.js.map